export default __webpack_public_path__ + "static/media/glrc-product.baking_and_pastry.f4710704.png";